<template>
<div>
    <div class="container">
        <logo/>
        <centered-card>
            <about/>
        </centered-card>
    </div>
</div>
</template>

<script>


    import Logo from './layout/CenterLogo.vue';
    import CenteredCard from "./layout/CenteredCard";
    import About from "./layout/About";

    export default {
        name: 'AboutPage',
        data(){
            return {

            }
        },

        methods: {},
        components:{
            About,
            CenteredCard,
            Logo
        }

    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/components/AboutPage.vue